import Box from "./base/Box";
import React from "react";
import SaveIcon from "@mui/icons-material/Save";
import HomeCard from "./base/HomeCard";

const QuickNotes = ({ update, setContent, content }) => {
  return (
    <HomeCard>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          flex: 6,
        }}
      >
        <Box component="h4" style={{ flex: 3 }}>
          Quick notes
        </Box>
        <Box
          sx={{ cursor: "pointer" }}
          onClick={() => {
            update();
          }}
        >
          <SaveIcon className="notesicn" />
        </Box>
      </Box>
      <Box
        component="textarea"
        className="notepadtxt"
        placeholder="Click here to take quick notes"
        onChange={(e) => {
          setContent(e.target.value);
        }}
      >
        {content}
      </Box>
    </HomeCard>
  );
};

export default QuickNotes;
